import * as Constants from '@/lib/constants'
import i18n from '@/lib/i18n'
import store from '@/store'

export default class Operation {
  static get UNDEFINED_NAME() {
    return '--'
  }

  static getColor(operationType) {
    const typeColor = Constants.OperationTypeColor[operationType]
    if (typeColor) {
      return typeColor
    }
    return Constants.OperationTypeColor['Other']
  }

  static getLocalizedName(operationType) {
    const types = store.getters.availableOperationTypes
    const language = i18n.getUserLang()
    if (operationType) {
      for (let i = 0; i < types.length; i++) {
        const value = types[i].value
        const text = types[i].localizedNames[language]
        if (value === operationType) {
          if (text === undefined) {
            return types[i].localizedNames.default
          }
          return text
        }
      }
    }
    return Operation.UNDEFINED_NAME
  }

  static getAvailableOperationTypesForOptions(language) {
    const types = store.getters.availableOperationTypes
    let opts = [{ value: null, text: Operation.UNDEFINED_NAME }]
    for (let i = 0; i < types.length; i++) {
      const value = types[i].value
      const text = types[i].localizedNames[language]
      opts.push({ value, text })
    }
    return opts
  }
}
